// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.create-member-container {
  padding: 0;
  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);
  min-height: 100vh;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

/* Hero Banner */
.create-member-hero-banner {
  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);
  color: white;
  padding: 40px 30px;
  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);
}

.create-member-hero-banner .hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.create-member-hero-banner h1 {
  margin: 0 0 10px 0;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.8px;
}

.create-member-hero-banner p {
  margin: 0;
  font-size: 15px;
  opacity: 0.95;
  max-width: 600px;
}

/* Card */
.create-member-card {
  background: white;
  padding: 28px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  margin: 30px;
  border: 1px solid rgba(16, 31, 56, 0.08);
  max-width: 560px;
}

/* Alerts */
.alert-success,
.alert-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-radius: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 600;
  border-left: 4px solid;
}

.alert-success {
  background: #e3efe9;
  color: #245349;
  border-left-color: #3d8a76;
}

.alert-error {
  background: #fbeae5;
  color: #8a3322;
  border-left-color: #c9563a;
}

/* Credentials Box */
.credentials-box {
  background: #f1ede2;
  border: 1px dashed #c6a15b;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 20px;
}

.credentials-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #48546b;
  margin-bottom: 10px;
}

.btn-copy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #101f38;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.btn-copy:hover {
  background: #132b4d;
}

.credentials-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid rgba(16, 31, 56, 0.08);
  font-size: 14px;
}

.credentials-row:last-child {
  border-bottom: none;
}

.credentials-label {
  color: #48546b;
  font-weight: 600;
}

.credentials-value {
  color: #0a1628;
  font-weight: 700;
  font-family: "Courier New", monospace;
}

/* Form */
.create-member-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #0a1628;
  font-size: 14px;
}

.form-group input,
.form-group select {
  padding: 10px 14px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #2f6f5e;
  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);
}

.form-hint {
  margin: 0;
  font-size: 13px;
  color: #48546b;
  background: #f1ede2;
  border-radius: 8px;
  padding: 10px 14px;
}

.input-readonly {
  background: #f1ede2;
  color: #48546b;
  cursor: not-allowed;
}

/* Password row */
.password-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.password-input-row input {
  flex: 1 1;
}

.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  background: white;
  color: #48546b;
  cursor: pointer;
  flex-shrink: 0;
}

.btn-icon:hover {
  background: #f1ede2;
}

.btn-generate {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 14px;
  height: 38px;
  border: none;
  border-radius: 6px;
  background: #c6a15b;
  color: white;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-generate:hover {
  background: #b38f4a;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

.btn-submit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #2f6f5e;
  color: white;
  flex: 1 1;
  justify-content: center;
}

.btn-submit:hover:not(:disabled) {
  background: #245349;
  transform: translateY(-1px);
}

.btn-submit:disabled {
  background: #d8cfb8;
  cursor: not-allowed;
  opacity: 0.7;
}

.spinner {
  animation: cm-spin 1s linear infinite;
}

@keyframes cm-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .create-member-container {
    padding: 0;
  }

  .create-member-card {
    margin: 20px;
    padding: 20px;
  }

  .password-input-row {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/CreateMember.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,UAAU;EACV,6DAA6D;EAC7D,iBAAiB;EACjB;;;;;cAKY;AACd;;AAEA,gBAAgB;AAChB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,WAAW;AACX;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Main Container */\n.create-member-container {\n  padding: 0;\n  background: linear-gradient(135deg, #f1ede2 0%, #e3ddcd 100%);\n  min-height: 100vh;\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    sans-serif;\n}\n\n/* Hero Banner */\n.create-member-hero-banner {\n  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);\n  color: white;\n  padding: 40px 30px;\n  box-shadow: 0 20px 50px rgba(16, 31, 56, 0.15);\n}\n\n.create-member-hero-banner .hero-badge {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  padding: 8px 16px;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.create-member-hero-banner h1 {\n  margin: 0 0 10px 0;\n  font-size: 32px;\n  font-weight: 800;\n  letter-spacing: -0.8px;\n}\n\n.create-member-hero-banner p {\n  margin: 0;\n  font-size: 15px;\n  opacity: 0.95;\n  max-width: 600px;\n}\n\n/* Card */\n.create-member-card {\n  background: white;\n  padding: 28px;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  margin: 30px;\n  border: 1px solid rgba(16, 31, 56, 0.08);\n  max-width: 560px;\n}\n\n/* Alerts */\n.alert-success,\n.alert-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 16px;\n  border-radius: 10px;\n  margin-bottom: 15px;\n  font-size: 14px;\n  font-weight: 600;\n  border-left: 4px solid;\n}\n\n.alert-success {\n  background: #e3efe9;\n  color: #245349;\n  border-left-color: #3d8a76;\n}\n\n.alert-error {\n  background: #fbeae5;\n  color: #8a3322;\n  border-left-color: #c9563a;\n}\n\n/* Credentials Box */\n.credentials-box {\n  background: #f1ede2;\n  border: 1px dashed #c6a15b;\n  border-radius: 12px;\n  padding: 16px 18px;\n  margin-bottom: 20px;\n}\n\n.credentials-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #48546b;\n  margin-bottom: 10px;\n}\n\n.btn-copy {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #101f38;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-copy:hover {\n  background: #132b4d;\n}\n\n.credentials-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  border-bottom: 1px solid rgba(16, 31, 56, 0.08);\n  font-size: 14px;\n}\n\n.credentials-row:last-child {\n  border-bottom: none;\n}\n\n.credentials-label {\n  color: #48546b;\n  font-weight: 600;\n}\n\n.credentials-value {\n  color: #0a1628;\n  font-weight: 700;\n  font-family: \"Courier New\", monospace;\n}\n\n/* Form */\n.create-member-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #0a1628;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group select {\n  padding: 10px 14px;\n  border: 1px solid #e3ddcd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #2f6f5e;\n  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);\n}\n\n.form-hint {\n  margin: 0;\n  font-size: 13px;\n  color: #48546b;\n  background: #f1ede2;\n  border-radius: 8px;\n  padding: 10px 14px;\n}\n\n.input-readonly {\n  background: #f1ede2;\n  color: #48546b;\n  cursor: not-allowed;\n}\n\n/* Password row */\n.password-input-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.password-input-row input {\n  flex: 1;\n}\n\n.btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 1px solid #e3ddcd;\n  border-radius: 6px;\n  background: white;\n  color: #48546b;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.btn-icon:hover {\n  background: #f1ede2;\n}\n\n.btn-generate {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 14px;\n  height: 38px;\n  border: none;\n  border-radius: 6px;\n  background: #c6a15b;\n  color: white;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.btn-generate:hover {\n  background: #b38f4a;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.btn-submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: #2f6f5e;\n  color: white;\n  flex: 1;\n  justify-content: center;\n}\n\n.btn-submit:hover:not(:disabled) {\n  background: #245349;\n  transform: translateY(-1px);\n}\n\n.btn-submit:disabled {\n  background: #d8cfb8;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.spinner {\n  animation: cm-spin 1s linear infinite;\n}\n\n@keyframes cm-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .create-member-container {\n    padding: 0;\n  }\n\n  .create-member-card {\n    margin: 20px;\n    padding: 20px;\n  }\n\n  .password-input-row {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
